export const theme = {
  colors: {
    primary: '#FF6B35', // 橙色主色调
    secondary: '#E55B2B', // 深橙色
    accent: '#FF8A5C', // 强调橙色
    background: '#FFFFFF',
    surface: '#FFF8F5', // 温暖的浅橙背景
    text: {
      primary: '#2C1810', // 深棕色文本
      secondary: '#8B4513', // 棕色
      light: '#CD853F', // 浅棕色
    },
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#06B6D4',
    border: {
      light: '#FFE4D6', // 浅橙边框色
      medium: '#FFD0B5',
      dark: '#FFBC94',
    },
  },
  gradients: {
    primary: 'linear-gradient(135deg, #FF6B35 0%, #E55B2B 100%)',
    secondary: 'linear-gradient(135deg, #FF8A5C 0%, #FF6B35 100%)',
    background: 'linear-gradient(135deg, #FFF8F5 0%, #FFE4D6 100%)',
  },
  shadows: {
    small: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    medium: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    large: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xlarge: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  borderRadius: {
    small: '6px',
    medium: '12px',
    large: '16px',
    xlarge: '24px',
    round: '50%',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  },
  typography: {
    fontFamily: {
      primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      secondary: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, sans-serif',
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '36px',
      xxxxl: '56px',
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.8,
    },
  },
};
